import { Promotion, PromotionParam } from 'src/models/Promotion'
import { IS_DEVELOPMENT } from 'src/utils/env'
import useSWR from 'swr'
import { fetcher } from './client'
import { getProfile, GET_ROOMS } from './endpoints'
import { toRecommendedUser } from './recommendation'
import { toRoomsQuery } from './room/converters'
import { Promotion as PromotionResponse } from './types/promotion'
import { RoomsResponse } from './types/room'

export const usePR = () =>
  useSWR([`${GET_ROOMS}${toRoomsQuery({ size: 0 })}`], prFetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    dedupingInterval: IS_DEVELOPMENT ? undefined : 86400000,
  })

const prFetcher = async (url: string): Promise<Promotion | undefined> => {
  const res: RoomsResponse = await fetcher(url)
  if (!res.promotion) return undefined
  return toPromotion(res.promotion)
}

export const toPromotion = (data: PromotionResponse) => ({
  id: data.id,
  token: data.authenticationToken,
  content: data.content,
  displayType: data.displayType,
  prDetail: data.prDetail,
  user: toRecommendedUser(data.company, data),
})

export const toQueryParam = (param: PromotionParam) =>
  new URLSearchParams({
    id: `${param.id}`,
    authentication_token: param.token,
  }).toString()

export const logPromotionClick = ({
  userId,
  id,
  token,
}: PromotionParam & { userId: number }) => {
  fetcher(getProfile(userId, { id, token }))
}
